export default __webpack_public_path__ + "static/IBMPlexSans-LightItalic-Latin2-eb36767a3caa8dfc71e8518867dd7370.woff2";